import { useNavigate } from "react-router-dom";
import { useCursor } from "../../context/CursorContext";
import SiteHeader from "./components/SiteHeader";
import Slideshow from "./components/Slideshow";
import ContactSection from "./components/ContactSection";

export default function Home({ introComplete }: { introComplete?: boolean }) {
  const navigate = useNavigate();
  const { setIsLightCursor } = useCursor();

  const goToContact = () => {
    setIsLightCursor(true);
    navigate("/contact");
  };

  return (
    <main
      className="flex flex-col lg:h-screen lg:overflow-hidden"
      style={{ backgroundColor: "#e6e4e1", minHeight: "100vh" }}
    >
      {/* Header — mobile only */}
      <div className="lg:hidden">
        <SiteHeader />
      </div>

      {/* Content area: two-column on desktop, stacked on mobile */}
      <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">

        {/* ── LEFT PANEL: Logo + Contact — desktop only ── */}
        <div className="hidden lg:flex flex-col items-end justify-between w-[480px] xl:w-[520px] shrink-0 pt-8 pr-10" style={{ paddingBottom: "clamp(110px, calc(50vh - 360px), 400px)" }}>
          {/* Spacer top */}
          <div className="flex-1 flex flex-col items-end justify-center gap-20">
            <a href="/" className="cursor-pointer flex justify-end">
              <img
                src="https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/39302b61-2181-4ec9-8d03-edfa08f3da49_Logo-ECOS4.3D-6.png?v=9954720132db01543c2273faeaa0dd90"
                alt="Logo"
                className="object-contain"
                style={{ width: "200px" }}
              />
            </a>
            <button
              onClick={goToContact}
              className="text-xs text-stone-500 hover:text-stone-800 transition-colors duration-300 cursor-pointer bg-transparent border-none outline-none whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500, letterSpacing: "normal" }}
            >
              contacto
            </button>
          </div>
          {/* Footer text */}
          <div className="text-right leading-relaxed">
            <p style={{ color: "#78716c", fontFamily: "'Inter', sans-serif", fontSize: "10px", fontWeight: 400 }}>© ECOS 3D</p>
            <p style={{ color: "#78716c", fontFamily: "'Inter', sans-serif", fontSize: "10px", fontWeight: 400 }}>Todos os direitos reservados</p>
          </div>
        </div>

        {/* ── RIGHT PANEL: Slideshow ── */}
        <Slideshow introComplete={introComplete} />

      </div>

      {/* ContactSection — mobile pill button only */}
      <ContactSection />
    </main>
  );
}
